import { SkeletonLoading } from "@/main/components/shared/styles";
import * as S from "./styles";

interface ISkeletonModalCancelPartsProps {}
function SkeletonModalCancelParts(_props: ISkeletonModalCancelPartsProps) {
	return (
		<S.SkeletonRowPart>
			<SkeletonLoading $height="80px" $forceWidth="80px" $margin="0 auto" />
			<SkeletonLoading />
			<SkeletonLoading $height="20px" $forceWidth="20px" $margin="0 auto" />
		</S.SkeletonRowPart>
	);
}

export default SkeletonModalCancelParts;
